import LegalPage from "./LegalPage";
import { useTranslation } from "react-i18next";
import IntegrationStatus from "@/components/transparencia/IntegrationStatus";

const Card = ({ subKey, bodyKey, testid }) => {
  const { t } = useTranslation();
  return (
    <div className="rounded-xl border hairline bg-white p-6" data-testid={testid}>
      <div className="text-[11px] uppercase tracking-[0.22em] text-salnes-stone mb-2">
        {t(subKey)}
      </div>
      <div className="text-sm text-salnes-ink/85 leading-relaxed">
        {t(bodyKey)}
      </div>
    </div>
  );
};

export function Transparencia() {
  const { t } = useTranslation();
  return (
    <LegalPage
      titleKey="legal.transparency_title"
      introKey="legal.transparency_intro"
      testid="page-transparencia"
      extra={
        <>
          <div className="grid md:grid-cols-2 gap-6">
            <Card
              subKey="legal.transparency_nextgen_sub"
              bodyKey="legal.transparency_nextgen_body"
              testid="transparencia-nextgen"
            />
            <div className="rounded-xl border hairline bg-white p-6" data-testid="transparencia-ai-act">
              <div className="text-[11px] uppercase tracking-[0.22em] text-salnes-stone mb-2">
                {t("legal.ai_act_label")}
              </div>
              <div className="text-sm text-salnes-ink/85 leading-relaxed">
                {t("legal.ai_notice")}
              </div>
            </div>
            <Card
              subKey="legal.transparency_rgpd_sub"
              bodyKey="legal.transparency_rgpd_body"
              testid="transparencia-rgpd"
            />
            <Card
              subKey="legal.transparency_legal_frame_sub"
              bodyKey="legal.transparency_legal_frame_body"
              testid="transparencia-legal-frame"
            />
          </div>
          <IntegrationStatus />
        </>
      }
    />
  );
}

export function Privacidade() {
  return (
    <LegalPage
      titleKey="legal.privacy_title"
      introKey="legal.privacy_intro"
      testid="page-privacidade"
      hero="hero-salnes-alt1"
      extra={
        <div className="grid md:grid-cols-2 gap-6" data-testid="privacidade-sections">
          <Card
            subKey="legal.privacy_responsable_sub"
            bodyKey="legal.privacy_responsable_body"
            testid="privacidade-responsable"
          />
          <Card
            subKey="legal.privacy_finalidade_sub"
            bodyKey="legal.privacy_finalidade_body"
            testid="privacidade-finalidade"
          />
          <Card
            subKey="legal.privacy_base_sub"
            bodyKey="legal.privacy_base_body"
            testid="privacidade-base"
          />
          <Card
            subKey="legal.privacy_dereitos_sub"
            bodyKey="legal.privacy_dereitos_body"
            testid="privacidade-dereitos"
          />
          <Card
            subKey="legal.privacy_prazo_sub"
            bodyKey="legal.privacy_prazo_body"
            testid="privacidade-prazo"
          />
          <Card
            subKey="legal.privacy_destinatarios_sub"
            bodyKey="legal.privacy_destinatarios_body"
            testid="privacidade-destinatarios"
          />
        </div>
      }
    />
  );
}

export function Accesibilidade() {
  return (
    <LegalPage
      titleKey="legal.accessibility_title"
      introKey="legal.accessibility_intro"
      testid="page-accesibilidade"
    />
  );
}

export function DatosAbertos() {
  return (
    <LegalPage
      titleKey="legal.opendata_title"
      introKey="legal.opendata_intro"
      testid="page-datos-abertos"
      hero="hero-salnes-alt1"
    />
  );
}
